import axios from "axios";
import { Message, Loading } from "element-ui";
// axios.defaults.baseURL = "http://106.15.199.41:8088";
axios.defaults.baseURL = "https://admin.kingcer.com";
axios.defaults.timeout = 20000;
axios.defaults.headers.post["Content-Type"] = "application/json;charset=utf-8";
const http = axios.create();

const post = http.post;
http.post = (url, params, options = {}, config = {}) => {
    const requestConfig = Object.assign({}, options, config);
    return post(url, params, requestConfig).then((data = {}) => {
        return Promise.resolve(data.data ? data.data.data : false);
    });
};

let loading;
function closeLoading() {
    if (loading && typeof loading.close === "function") {
        loading.close();
    }
}
// 请求拦截器
http.interceptors.request.use(
    config => {
        let info = window.localStorage.getItem("info");
        if (info) {
            config.headers.token = `${JSON.parse(info).token}`;
        }
        // 加载提示
        loading = Loading.service({
            lock: true,
            text: "数据加载中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.2)"
        });
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// 响应拦截器
http.interceptors.response.use(
    response => {
        if (String(response.data.code) === "200") {
            // 成功
            closeLoading();
            return response;
        } else if (String(response.data.code) === "1004") {
            // token
            closeLoading();
            window.localStorage.clear();
            Message.error("登录过期,请重新登录");
            location.href = "/";
        } else {
            if (response.config.responseType === "blob") {
                closeLoading();
                return response;
            } else {
                closeLoading();
                Message.error(
                    response.data.msg ||
                    response.data.message ||
                    "数据加载失败，请刷新页面重试！"
                );
            }
        }
    },
    error => {
        closeLoading();
        Message.error("网络异常，请刷新页面重试！");
        return Promise.reject(error);
    }
);

export default http;




// WEBPACK FOOTER //
// ./src/api/index.js